'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './memberTransaction.routes.js';
import MemTransactionListCtrl from './list/list.controller.js';
import MemTransactionViewCtrl from './view/view.controller.js';
import MemTransactionFormCtrl from './form/form.controller.js';

export default angular.module('georgeApp.memberTransaction',
  [uiRouter])
  .config(routing)
  .controller('MemTransactionListCtrl', MemTransactionListCtrl)
  .controller('MemTransactionViewCtrl', MemTransactionViewCtrl)
  .controller('MemTransactionFormCtrl', MemTransactionFormCtrl)
  .name;
